import { render } from "./index.vue?vue&type=template&id=795b886f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/rich/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "795b886f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('795b886f', __exports__)) {
    console.log('reload')
    api.reload('795b886f', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=795b886f", () => {
    console.log('re-render')
    api.rerender('795b886f', render)
  })

}


export default __exports__